<template>
    <div>
        <NavBar />
        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Message
                    </h1>
                </div>
            </header>
        </div>
        <main class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-2/3 cursor-pointer">
                            <div class="flex flex-wrap">
                                <template v-if="messageType === ''">
                                    <div class="w-full px-3">
                                        <div class="Box">
                                            <div class="Box-body">
                                                Please choose a
                                                <router-link to="/message_type">
                                                    message type.
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="w-full px-2" v-if="messageType === 'sms'">
                                        <div class="bg-white rounded p-4">
                                            <label class="block text-gray-700 text-sm font-bold my-2" for="category">
                                                Category
                                            </label>
                                            <select
                                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                id="frequency"
                                                name="frequency"
                                                required
                                            >
                                                <option value="marketing" selected> Marketing </option>
                                            </select>

                                            <label class="block text-gray-700 text-sm font-bold my-2" for="template">
                                                Template
                                            </label>
                                            <select
                                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                id="template"
                                                name="template"
                                                required
                                            >
                                            </select>

                                            <textarea class="resize-none border rounded focus:outline-none mt-2 w-full p-2" rows="10"
                                                @change="handleChange"
                                                :value="message"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div
                                        class="w-full"
                                        v-else-if="messageType === 'audio'"
                                    >
                                        <div class="rounded">
                                            <div class="flex flex-wrap">
                                                <div class="w-full md:w-1/2 px-2">
                                                    <div class="rounded overflow-hidden hover:shadow py-2 bg-white cursor-pointer"
                                                        @click="changeInputType('upload')"
                                                    >
                                                        <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                        </svg>
                                                        <div class="px-6 py-4 text-center">
                                                            <div class="font-bold text-xl mb-2">Upload Audio File</div>
                                                            <p class="text-gray-700 text-sm">
                                                                Only .wav files are supported
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="w-full md:w-1/2 px-2">
                                                    <div class="rounded overflow-hidden hover:shadow py-2 bg-white cursor-pointer" 
                                                        @click="changeInputType('existing')"
                                                    >
                                                        <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                                        </svg>
                                                        <div class="px-6 py-4 text-center">
                                                            <div class="font-bold text-xl mb-2">Choose Uploaded Audio</div>
                                                            <p class="text-gray-700 text-sm">
                                                                Choose from previously uploaded audio files
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div
                                                class="w-full md:w-1/3 bg-gray-light text-center p-5 pointer"
                                                @click="changeInputType('record')"
                                            >
                                                <h4 class="my-2">Record Audio</h4>
                                                <img
                                                    class="object-contain w-full"
                                                    src="../assets/images/dashboard_img/record_audio.png"
                                                >
                                            </div>
                                        -->

                                        <div class="border-dashed border-4 mx-2 my-4 p-4">
                                            <template v-if="audioInputType === 'upload'">
                                                <div class="Telepathy-Box-header">
                                                    <h3 class="Box-title">
                                                        Upload audio file
                                                    </h3>
                                                </div>
                                                <div class="Box-row">
                                                    <input
                                                        type="file"
                                                        @change="processFile"
                                                    />
                                                </div>
                                            </template>
                                            <template v-else-if="audioInputType === 'record'">
                                                <div class="Telepathy-Box-header">
                                                    <h3 class="Box-title">
                                                        Record Audio In Your Browser
                                                    </h3>
                                                </div>
                                                <div class="Box-row">
                                                    <div
                                                        class="d-flex flex-justify-center"
                                                        id="controls"
                                                        v-if="showRecorder"
                                                    >
                                                        <audio-recorder
                                                            upload-url="/api/v1/recordings"
                                                            format="WAV"
                                                            :time="2"
                                                            :attempts="1"
                                                            :headers="headers"
                                                            :successful-upload="recUploadSuccess"
                                                            :failed-upload="recUploadFailed"
                                                        />
                                                    </div>

                                                    <p v-if="uploaded">
                                                        Your recording has been succesfully uploaded
                                                    </p>
                                                    <p v-else-if="uploadError">
                                                        {{ uploadErrorMessage }}
                                                    </p>
                                                </div>
                                            </template>
                                            <template v-else-if="audioInputType === 'existing'">
                                                <h3 class="text-lg font-medium">Choose from previously uploaded audio files</h3>
                                                <div
                                                    class="my-2 bg-gray-200 p-2 rounded"
                                                    v-for="recording in recordings"
                                                    :key="recording.id"
                                                    @click="selectRecording(recording.id)"
                                                >
                                                    <p> {{ recording.file_name }} </p>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="w-full md:w-1/3">
                            <Summary :summary="summary" />

                            <button
                                class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-2 px-4 rounded my-4"
                                @click="save"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Summary from "../components/Summary";
import NavBar from "../components/NavBar";
// import AudioRecorder from "vue-audio-recorder"
import { api } from "../store/http";

// Vue.use(AudioRecorder);

export default {
    name: "Message",
    components: {
        Summary,
        NavBar,
    },
    data() {
        return {
            audioInputType: "",
            uploaded: false,
            uploadError: false,
            uploadErrorMessage: "",
            blocked: false,
            headers: {
              "Authorization": localStorage.getItem("token")
            },
            showRecorder: true,
            summary: {
                "message_type": "",
                "contact_list_id": "",
                "contact_list_type": "",
                "text_message": "",
                "message_recording_type": "",
                "uploaded_audio_file": "",
            }
        }
    },
    methods: {
        selectRecording(id) {

            this.summary.message_recording_type = "Audio File";

            this.$store.dispatch("commitMultiple", [{
                    prop: "recording",
                    val: id
                },
                {
                    prop: "audioUploadType",
                    val: "Audio File"
                }
            ]);
        },
        handleChange({ target: { value }}) {
            if(this.message !== value) {
                const payload = {
                    prop: "message",
                    val: value
                };
                this.$store.commit("change", payload);

                if(value !== "")
                    this.summary.text_message = "Written";
                else 
                    this.summary.text_message = "";

            }
        },
        changeInputType(type) {
            this.audioInputType = type;
        },
        recUploadSuccess({ data: { payload } }) {
            this.$store.dispatch("commitMultiple", [{
                    prop: "recording",
                    val: payload.id
                },
                {
                    prop: "audioUploadType",
                    val: "Record Audio"
                }
            ]);

            /// Update summary
            this.summary.message_recording_type = "Record Audio";
            this.summary.uploaded_audio_file = payload.file_name;
            this.uploaded = true;
            this.showRecorder = false;

            // Update recordings
            this.$store.dispatch("loadRecordings");
        },
        recUploadFailed({ data: { payload } }) {
            this.uploadError = true;
            this.uploadErrorMessage = data.message;
        },
        processFile({ target }) {
            let [ file ] = target.files;
            let formData = new FormData();
            formData.append("upload_request[name]", file.name);
            formData.append("upload_request[file]", file);

            api.post("recordings", formData)
                .then((response) => {
                    let { data: { payload } } = response;

                    this.$store.dispatch("commitMultiple", [{
                            prop: "recording",
                            val: payload.id
                        },
                        {
                            prop: "audioUploadType",
                            val: "Audio File"
                        }
                    ]);

                    this.uploaded = true;
                    /// Update summary
                    this.summary.message_recording_type = "Audio File";
                    this.summary.uploaded_audio_file = file.name;

                    // Update recordings
                    this.$store.dispatch("loadRecordings");
                })
                .catch(({ response }) => {
                    // this.uploadError = true;
                    // this.uploadErrorMessage = data.message;
                    console.log(response);
                });
        },
        save() {
            // this.blocked = true;
            // if (this.messageType === "audio") {

                // this.$api.patch(`campaigns/${this.currentCampaignId}`, {
                //     recording: this.recording
                // })
                // .then(response => {
                //     this.$router.push(this.nextRoute);
                // })
                // .catch(error => {
                //     this.blocked = false;
                // });
            // } else {
            //     }
            this.$router.push(this.nextRoute);
        },
    },
    computed: {
        nextRoute() {
            return `${this.$route.meta.link}`;
        },
        ...mapGetters([
            "messageTypeFormatted",
            "messageType",
            "message",
            "contactList",
            "selectedList",
            "contactListType",
            "recording",
            "recordings"
        ]),
    },
    mounted() {
        this.$store.dispatch("loadRecordings");

        this.summary.message_type = this.messageTypeFormatted;

        if(this.summary.message_type === "Text Message" && this.message !== "") {
            this.summary.text_message = "Written";
            this.summary.message_recording_type = "";
            this.summary.audio_recording_type = "";
        };

        const contactList = this.contactList(this.selectedList);

        if(contactList) {
            this.summary.contact_list_type = this.contactListType;
            this.summary.contact_list_id = this.contactList(this.selectedList).description;
        }
    }
}
</script>